/* Bistoukette — JS minimal */
document.addEventListener('click', function (e) {
  var toggle = e.target.closest('[data-nav-toggle]');
  if (toggle) {
    var nav = document.getElementById('site-nav');
    if (nav) {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  var thumb = e.target.closest('[data-thumb]');
  if (thumb) {
    var main = document.getElementById('product-main-image');
    if (main) {
      main.src = thumb.dataset.thumb;
      main.srcset = '';
      document.querySelectorAll('[data-thumb]').forEach(function (b) {
        b.setAttribute('aria-current', b === thumb ? 'true' : 'false');
      });
    }
  }
});

/* Sélecteur de variante : met à jour prix, dispo et URL */
document.addEventListener('change', function (e) {
  var select = e.target.closest('[data-variant-select]');
  if (!select) return;
  var root = select.closest('[data-product-root]');
  if (!root) return;
  var data = JSON.parse(root.querySelector('[data-variants-json]').textContent);
  var variant = data.find(function (v) { return String(v.id) === select.value; });
  if (!variant) return;

  var nameEl = root.querySelector('[data-swatch-name]');
  if (nameEl && select.dataset.name) nameEl.textContent = select.dataset.name;

  var priceEl = root.querySelector('[data-price]');
  if (priceEl) priceEl.textContent = variant.price;

  var btn = root.querySelector('[data-add-button]');
  if (btn) {
    btn.disabled = !variant.available;
    btn.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
  }

  var stock = root.querySelector('[data-stock]');
  if (stock) stock.textContent = variant.stock_label || '';

  if (variant.image) {
    var main = document.getElementById('product-main-image');
    if (main) { main.src = variant.image; main.srcset = ''; }
    root.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.setAttribute('aria-current', b.dataset.thumb === variant.image ? 'true' : 'false');
    });
  }

  if (history.replaceState) {
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url.toString());
  }
});

/* --- Carrousel de coloris --- */
(function () {
  function cards(track) {
    return Array.prototype.slice.call(track.querySelectorAll('.vcard, .ecard'));
  }
  function step(track) {
    var list = cards(track);
    if (!list.length) return track.clientWidth * 0.8;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 16;
    var per = Math.max(1, Math.floor(track.clientWidth / (list[0].offsetWidth + gap)));
    return (list[0].offsetWidth + gap) * per;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function sync(root, track) {
    var prev = root.querySelector('[data-vc-prev]');
    var next = root.querySelector('[data-vc-next]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
    root.classList.toggle('is-static', max <= 2);
    var list = cards(track);
    var bar = root.querySelector('[data-vc-bar]');
    if (bar) {
      var visible = Math.min(1, track.clientWidth / Math.max(track.scrollWidth, 1));
      var ratio = max > 0 ? track.scrollLeft / max : 0;
      bar.style.width = (visible * 100) + '%';
      bar.style.transform = 'translateX(' + (ratio * (1 / visible - 1) * 100) + '%)';
    }
    var count = root.querySelector('[data-vc-count]');
    if (count && list.length) {
      var w = list[0].offsetWidth || 1;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      var first = Math.min(list.length, Math.round(track.scrollLeft / (w + gap)) + 1);
      count.textContent = pad(first) + ' / ' + pad(list.length);
    }
  }
  document.querySelectorAll('[data-vcarousel]').forEach(function (root) {
    var track = root.querySelector('[data-vc-track]');
    if (!track) return;
    sync(root, track);
    track.addEventListener('scroll', function () { sync(root, track); }, { passive: true });
    window.addEventListener('resize', function () { sync(root, track); });
    root.querySelectorAll('[data-vc-prev],[data-vc-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.hasAttribute('data-vc-next') ? 1 : -1;
        track.scrollBy({ left: dir * step(track), behavior: 'smooth' });
      });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      track.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * step(track), behavior: 'smooth' });
    });
  });
})();

/* --- Apparition progressive --- */
(function () {
  var items = document.querySelectorAll('.reveal');
  if (!items.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    var i = 0;
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      el.style.transitionDelay = (Math.min(i++, 5) * 70) + 'ms';
      el.classList.add('is-in');
      el.addEventListener('transitionend', function () { el.style.transitionDelay = ''; }, { once: true });
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8%' });
  items.forEach(function (el) { io.observe(el); });
})();

/* --- Cartes édition : défilement des coloris sur la photo --- */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cardsList = document.querySelectorAll('[data-ecard]');
  if (!cardsList.length || reduce) return;

  cardsList.forEach(function (card, cardIndex) {
    var imgs = card.querySelectorAll('.ecard__img');
    if (imgs.length < 2) return;
    var ticks = card.querySelectorAll('.ecard__ticks i');
    var nameEl = card.querySelector('[data-ecard-name]');
    var root = card.closest('[data-cycle]');
    var delay = root ? parseInt(root.getAttribute('data-cycle'), 10) || 2000 : 2000;
    var base = card.getAttribute('data-base-url');
    var i = 0, timer = null, visible = false, paused = false;

    function show(n) {
      imgs[i].classList.remove('is-active');
      if (ticks[i]) ticks[i].classList.remove('is-active');
      i = n;
      imgs[i].classList.add('is-active');
      if (ticks[i]) ticks[i].classList.add('is-active');
      if (nameEl) {
        nameEl.classList.add('is-changing');
        setTimeout(function () {
          nameEl.textContent = imgs[i].getAttribute('data-name');
          nameEl.classList.remove('is-changing');
        }, 250);
      }
      if (base) card.setAttribute('href', base + '?variant=' + imgs[i].getAttribute('data-variant'));
    }
    function start() {
      if (timer || paused || !visible) return;
      timer = setInterval(function () { show((i + 1) % imgs.length); }, delay);
    }
    function stop() { clearInterval(timer); timer = null; }

    /* décalage pour que les cartes ne changent pas toutes en même temps */
    setTimeout(function () {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        visible ? start() : stop();
      }, { threshold: 0.35 }).observe(card);
    }, cardIndex * 450);

    /* pause au survol / au focus : on peut cliquer sur le coloris affiché */
    card.addEventListener('mouseenter', function () { paused = true; stop(); });
    card.addEventListener('mouseleave', function () { paused = false; start(); });
    card.addEventListener('focusin', function () { paused = true; stop(); });
    card.addEventListener('focusout', function () { paused = false; start(); });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  });
})();
